(function ($) {
	'use strict';

	/**
	 * Run balanceText
	 *
	 * @see presi/Setup/Scripts::load_cdn_scripts()
	 */
	$(function () {
		// noinspection JSUnresolvedFunction
		balanceText($('.balance-text, .entry-title-primary, .entry-subtitle, .product_title, .entry-title'), {watch: true});
	});

	/**
	 * Add class to select elements with no value so default placeholder options
	 * can be styled
	 */
	$(function () {

		//add/remove style as appropriate
		const styleSelect = function ($this) {
			if ($this.val()) {
				$this.removeClass('no-val');
			} else {
				$this.addClass('no-val');
			}
		};

		const $select = $('select');

		//when select changes
		$select.on('change', function () {
			styleSelect($(this));
		});

		//style all on page load
		$select.each(function () {
			styleSelect($(this));
		});

	});

	/**
	 * Link a whole block
	 */
	$(function () {

		const $linkBlocks = $('.link-whole-block');

		$linkBlocks.find('a').first().addClass('no-link-style');

		$linkBlocks.click(function () {
			const target = $(this).find('a').first().attr('href');
			location.assign(target);
		});

	});


}(jQuery));
